<template>
  <div v-if="loading">
    <v-row justify="center" align-content="center" class="mt-10">
      <img src="../../assets/loading.gif">
    </v-row>
  </div>
  <div v-else>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
        <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a>
      </v-col>
      <v-col md="8" sm=12 style="background-color: #FFFFFF; position: relative;" class="">
        <v-row v-if="page" justify="center" align-content="center" class="mt-10">
          <v-card-title class="font-weight-black">
            <p>ユーザー登録完了しました！</p>
          </v-card-title>
        </v-row>
        <v-row v-else>
          <v-card-title class="font-weight-black">
            <p>無効なURLです。操作をやり直してください</p>
          </v-card-title>
        </v-row>
        <v-row justify="center" align-content="center" class="mt-10">
          <v-btn
              to="/login"
              color="primary"
              class="button-shadow ma-4"
              width="30%"
          >ログイン画面へ</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'email_verifiy',
  data() {
    return {
      page: true,
      height: 500,
      loading: true,
    }
  },
  created() {
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/email_verifiy/?m=' + this.$route.params.email_token)
    .then(() => {
      this.page = true
      this.loading = false
    })
    .catch(() => {
      this.page = false
      this.loading = false
    });
  },
}
</script>